import { Text } from '@ds'
import { DotLottieWorkerReact } from '@lottiefiles/dotlottie-react'
import classNames from 'classnames'
import { motion } from 'framer-motion'

import styles from './Loader.module.scss'
import loaderAnim from './assets/preloader.json'

type Props = {
  className?: string
  title?: string
}

export const Loader = ({ className, title }: Props) => {
  return (
    <>
      <motion.div
        className={classNames(styles.loaderWrapper, className)}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
      >
        <div className={styles.loaderContainer}>
          <DotLottieWorkerReact
            autoplay
            loop
            data={loaderAnim}
          />
        </div>
        {title && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <div className={styles.text}>{title}</div>
          </motion.div>
        )}
      </motion.div>
    </>
  )
}
